var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('PetSearch',{staticClass:"pet-search",attrs:{"addButton":_vm.$isGod()},on:{"selected":_vm.onSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }